var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[(_vm.$routerHistory.hasPrevious())?_c('v-btn',{attrs:{"small":"","to":{ path: _vm.$routerHistory.previous().path }}},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e(),_vm._v(" "),_c('v-spacer',[_c('p',{staticClass:"title text-md-center"},[_vm._v(_vm._s(_vm.titulo))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d4037bb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BackMenuComponent.vue
// module id = null
// module chunks = 